import { jsx as _jsx } from "react/jsx-runtime";
import { MarketItemModalForm } from '../EntityModalForms/MarketItemModalForm';
function EditMarketItemModal({ isOpen, onClose, onUpdate, item, isLoading }) {
    return (_jsx(MarketItemModalForm, { isOpen: isOpen, onClose: onClose, onSubmit: onUpdate, isLoading: isLoading, mode: "edit", item: item, title: "Edit Market Item", submitIdleLabel: "Update", submitBusyLabel: "Updating..." }));
}
export default EditMarketItemModal;
